import { daysUntil } from '@/shared/format/date'

export type Urgency = 'critical' | 'attention' | 'upcoming' | 'done' | 'neutral'

const HARD_CRITICAL_DAYS = 7
const HARD_ATTENTION_DAYS = 30
const SOFT_ATTENTION_DAYS = 14

export interface Dated {
  deadline?: string | undefined
  hard_deadline?: boolean | undefined
}

export function urgencyOfDays(days: number | undefined, hard = false): Urgency {
  if (days === undefined) {
    return 'neutral'
  }

  if (days < 0) {
    return 'critical'
  }

  if (hard) {
    return days <= HARD_CRITICAL_DAYS
      ? 'critical'
      : days <= HARD_ATTENTION_DAYS
        ? 'attention'
        : 'upcoming'
  }

  return days <= SOFT_ATTENTION_DAYS ? 'attention' : 'upcoming'
}

export function urgencyOf(item: Dated): Urgency {
  if (!item.deadline) {
    return 'neutral'
  }

  return urgencyOfDays(daysUntil(item.deadline), item.hard_deadline ?? false)
}

export function needsAttention(urgency: Urgency): boolean {
  return urgency === 'critical' || urgency === 'attention'
}

const rank: Record<Urgency, number> = {
  critical: 0,
  attention: 1,
  upcoming: 2,
  neutral: 3,
  done: 4,
}

export function byUrgency(a: Urgency, b: Urgency): number {
  return rank[a] - rank[b]
}
